import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

import news11Yonghe from '../assets/images/news-11-yonghe.png'
import news11Banqiao from '../assets/images/news-11-banqiao.png'
import ios from '../assets/images/app-store.svg'
import google from '../assets/images/google-play.svg'

const News11 = props => (
  <Layout>
    <Helmet>
      <title>【 公告｜部分資費調整 】</title>
      <meta name="description" content="三健客部分資費調整" />
    </Helmet>

    <div id="main" className="alt">
      <section id="one">
        <div className="inner">
          <header className="major">
            <h1>【 公告｜部分資費調整 】</h1>
          </header>
          <div className="box alt">
            <div className="grid-wrapper">
              <div className="col-4">
                <span className="image main">
                  <img src={news11Yonghe} alt="永和店收費調整" />
                </span>
              </div>
              <div className="col-4">
                <span className="image main">
                  <img src={news11Banqiao} alt="板橋店收費調整" />
                </span>
              </div>
            </div>
          </div>
          <p>
            三健客從 2019
            年開幕至今，陪伴大家一路走過板橋店、永和店，感謝每一位健客一路以來的支持與陪伴
            ❤️
          </p>
          <p>
            為了持續維護大家的運動權益，並提供舒適、高 C/P 值的訓練環境 💪🏻
            <br />
            我們將針對兩間店的收費方式進行調整，詳細內容如下：
          </p>
          <h2>📍 永和店</h2>
          <p>
            月費方案維持不變
            <br />
            ❌ 移除一週 $299 方案
            <br />
            🏋️‍♂️ 單次入場 $200
            <br />
            🏋️‍♂️ 分鐘計費 $1.2／分
          </p>
          <p>另外，新增尖峰時段分鐘計費：</p>
          <h3>
            🔥 尖峰時段 $1.5／分
            <br />
            ・平日 17:00－22:00
            <br />
            ・假日 13:00－18:00
          </h3>
          <h2>📍 板橋店</h2>
          <p>
            🏋️‍♂️ 月費調整為 $999
            <br />
            ❌ 移除一週 $299 方案
            <br />
            🏋️‍♂️ 單次入場 $200
            <br />
            🏋️‍♂️ 分鐘計費 $1.2／分
          </p>
          <p>另外，新增尖峰時段分鐘計費：</p>
          <h3>
            🔥 尖峰時段 $1.5／分
            <br />
            ・平日 17:00－21:00
            <br />
            ・假日 13:00－18:00
          </h3>
          <h3>💡 注意事項</h3>
          <p>
            尖峰時段將依上述時段採 $1.5／分鐘計費，其餘時段維持原分鐘計費方式。
          </p>
          <p>
            我們希望透過不同的收費方案，讓健客們能依照自己的訓練時間與習慣，選擇最適合自己的方案。
          </p>
          <p>
            再次感謝大家一路以來對三健客的支持與愛護 ❤️
            <br />
            我們也會持續努力，提供更舒適、更完善的訓練環境給大家！
          </p>
          <p>如有任何問題，歡迎私訊我們 💬</p>
          <ul className="icons">
            <li>
              <a
                href="https://www.facebook.com/3muscler/"
                className="icon alt fa-facebook"
              >
                <span className="label">Facebook</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/3musclers/?hl=zh-tw"
                className="icon alt fa-instagram"
              >
                <span className="label">Instagram</span>
              </a>
            </li>
            <li>
              <a
                href="https://apps.apple.com/tw/app/3musclers-%E4%B8%89%E5%81%A5%E5%AE%A2%E5%81%A5%E8%BA%AB%E4%BF%B1%E6%A8%82%E9%83%A8/id1486517436"
                style={{ top: '10px' }}
                className="icon svg"
              >
                <img src={ios} alt="ios" />
              </a>
            </li>
            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.appworkout.fitbutler.threemusclers&hl=zh_TW"
                style={{ top: '10px' }}
                className="icon svg"
              >
                <img src={google} alt="google" />
              </a>
            </li>
          </ul>
          <iframe
            title="facebook-like"
            src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2F3muscler%2F&width=450&layout=standard&action=like&size=small&share=true&height=35&appId=3212226998840909"
            width="450"
            height="35"
            scrolling="no"
            frameBorder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
        </div>
      </section>
    </div>
  </Layout>
)

export default News11
